import React from 'react';
import clsx from 'clsx';

import { Checkbox as HeadlessCheckbox } from '@headlessui/react';

export function Checkbox({checked, disabled, onChange, children}
  : {checked: boolean, disabled?: boolean, onChange?: (checked: boolean) => void, children?: React.ReactNode}) {

  if(typeof onChange !== 'function') {
    onChange = () => {};
  }

  return (
    <fieldset className="tw-flex tw-items-start tw-gap-2">
      <HeadlessCheckbox checked={checked} onChange={onChange} disabled={disabled}
        className="tw-group tw-block tw-size-7 md:tw-size-5 tw-border-solid tw-border-2 tw-border-gray-400 data-[checked]:tw-border-blue-light data-[disabled]:tw-border-gray-300">
          <svg className="sa-stroke-lightblue tw-opacity-0 group-data-[checked]:tw-opacity-100 group-data-[disabled]:tw-stroke-gray-400" viewBox="0 0 14 14" fill="none">
            <path d="M3 8L6 11L11 3.5" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
      </HeadlessCheckbox>
      <label className="tw-m-0" onClick={() => !disabled && onChange(!checked)}>{children}</label>
    </fieldset>
  )
}


export function CheckRadio({checked, disabled, color}
  : {checked: boolean, disabled?: boolean, color: 'blue' | 'white' }) {

  return (
    <fieldset className="tw-flex tw-items-start tw-gap-2">
      <HeadlessCheckbox checked={checked} disabled={disabled}
        className={clsx("tw-group tw-flex tw-items-center tw-justify-center tw-size-7 md:tw-size-5 tw-border-solid tw-border-2 tw-rounded-full", 
        "tw-border-gray-400 data-[disabled]:tw-border-gray-400",
        `data-[checked]:${color === 'blue' ? 'tw-border-blue-sa' : 'tw-border-white'}`,
        "tw-cursor-pointer"
      )}>
          <div className={clsx("tw-top-1/2 tw-left-1/2 tw-invisible tw-size-4 md:tw-size-3 tw-rounded-full", 
            "group-data-[disabled]:tw-bg-gray-400 group-data-[checked]:tw-visible tw-z-1",
            color === 'blue' ? 'tw-bg-blue-sa' : 'tw-bg-white'
          )} />
      </HeadlessCheckbox>
    </fieldset>
  )
}